<h2 mat-dialog-title class="flex items-center gap-2 text-lg font-bold mb-1">
    <mat-icon>history</mat-icon>
    <span>Historial de Cambios - Pedido {{data?.serial || data?.after?.serial}}</span>
</h2>

<mat-dialog-content class="p-4">
    <!-- Selectores de versión cuando hay historial -->
    <div *ngIf="historyItems.length > 1" class="version-selectors mb-4 p-4 bg-gray-50 rounded-lg">
        <div class="flex items-center gap-4">
            <mat-form-field appearance="outline" class="flex-1">
                <mat-label>Versión anterior</mat-label>
                <mat-select [(value)]="selectedVersion1" (selectionChange)="onVersionChange()">
                    <mat-option *ngFor="let item of historyItems.slice(1)" [value]="item.version">
                        V{{item.version}} - {{item.updatedAt | date:'dd-MM-yyyy HH:mm'}} - {{item.updatedBySession?.username ||
                        'Sistema'}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-icon class="text-gray-500">compare_arrows</mat-icon>

            <mat-form-field appearance="outline" class="flex-1">
                <mat-label>Versión actual</mat-label>
                <mat-select [(value)]="selectedVersion2" (selectionChange)="onVersionChange()">
                    <mat-option *ngFor="let item of historyItems" [value]="item.version">
                        V{{item.version}} - {{item.updatedAt | date:'dd-MM-yyyy HH:mm'}} - {{item.updatedBySession?.username ||
                        'Sistema'}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <mat-tab-group>
        <!-- Pestaña de Resumen -->
        <mat-tab label="Resumen">
            <div class="mt-4">
                <table mat-table [dataSource]="getFieldChanges()" class="w-full">
                    <ng-container matColumnDef="field">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let item">{{item.field}}</td>
                    </ng-container>

                    <ng-container matColumnDef="before">
                        <th mat-header-cell *matHeaderCellDef>Antes</th>
                        <td mat-cell *matCellDef="let item">
                            <span *ngIf="item.isNumber">{{item.before | decimalFormat}}</span>
                            <span *ngIf="item.isDate">{{item.before | date:'dd-MM-yyyy HH:mm'}}</span>
                            <span *ngIf="!item.isNumber && !item.isDate">{{item.before || '-'}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="after">
                        <th mat-header-cell *matHeaderCellDef>Después</th>
                        <td mat-cell *matCellDef="let item">
                            <span *ngIf="item.isNumber">{{item.after | decimalFormat}}</span>
                            <span *ngIf="item.isDate">{{item.after | date:'dd-MM-yyyy HH:mm'}}</span>
                            <span *ngIf="!item.isNumber && !item.isDate">{{item.after || '-'}}</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </mat-tab>

        <!-- Pestaña de Detalles -->
        <mat-tab label="Detalles Modificados">
            <div class="mt-4">
                <table mat-table [dataSource]="getChangedDetails()" class="w-full mt-4">
                    <!-- Columna Posición -->
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef>Posición</th>
                        <td mat-cell *matCellDef="let item">{{item.position}}</td>
                    </ng-container>

                    <!-- Columna Material -->
                    <ng-container matColumnDef="material">
                        <th mat-header-cell *matHeaderCellDef class="text-center">Material</th>
                        <td mat-cell *matCellDef="let item" class="text-[12px]">
                                 <div class="text-content">
                                    <b class="f-10" *ngIf="getCode(item.material) as code">
                                        {{ code }} <br>
                                    </b>
                                    <span class="font-descrip">{{item?.material?.name}}</span>
                                </div>
                        </td>
                    </ng-container>

                    <!-- Cantidad (Antes) -->
                    <ng-container matColumnDef="quantityBefore">
                        <th mat-header-cell *matHeaderCellDef class="text-right">Cantidad Solicitada (Antes)</th>
                        <td mat-cell *matCellDef="let item" class="text-gray-500 text-right">
                            <span *ngIf="findOriginalDetail(item.position) as original">
                                {{original.soldQuantity | number:'1.3'}}
                                {{original.soldUnitOfMeasure?.code || ''}}
                            </span>
                            <span *ngIf="!findOriginalDetail(item.position)">-</span>
                        </td>
                    </ng-container>

                    <!-- Cantidad (Después) -->
                    <ng-container matColumnDef="quantityAfter">
                        <th mat-header-cell *matHeaderCellDef  class="text-right">Cantidad Solicitada (Después)</th>
                        <td mat-cell *matCellDef="let item"
                            class="text-right"
                            [class.text-green-600]="findOriginalDetail(item.position)?.soldQuantity !== item.soldQuantity">
                            {{item.soldQuantity | number:'1.3'}}
                            {{item.soldUnitOfMeasure?.code}}
                        </td>
                    </ng-container>

                    <!-- Cantidad (Antes) -->
                    <ng-container matColumnDef="quantityConfirmedBefore">
                        <th mat-header-cell *matHeaderCellDef class="text-right">
                            Cantidad Confirmada (Antes)
                        </th>

                        <td mat-cell *matCellDef="let item" class="text-gray-500 text-right">
                            <ng-container *ngIf="findOriginalDetail(item.position) as original">
                            <ng-container *ngIf="original.stockConfirmedBase !== null && original.stockConfirmedBase !== undefined; else dash">
                                {{ original.stockConfirmedBase | number:'1.3' }}
                                {{ original.stockConfirmedUnitOfMeasure?.code || '' }}
                            </ng-container>
                            </ng-container>

                            <ng-template #dash>-</ng-template>
                        </td>
                    </ng-container>

                    <!-- Cantidad (Después) -->
                    <ng-container matColumnDef="quantityConfirmedAfter">
                        <th mat-header-cell *matHeaderCellDef  class="text-right">Cantidad Confirmada (Después)</th>
                        <td mat-cell *matCellDef="let item"
                            class="text-right"
                            [class.text-green-600]="findOriginalDetail(item.position)?.stockConfirmedBase !== item.stockConfirmedBase">
                            {{item.stockConfirmedBase | number:'1.3'}}
                            {{item.stockConfirmedUnitOfMeasure?.code}}
                        </td>
                    </ng-container>

                    <!-- Precio (Antes) -->
                    <ng-container matColumnDef="priceBefore">
                        <th mat-header-cell *matHeaderCellDef class="text-right">Precio (Antes)</th>
                        <td mat-cell *matCellDef="let item" class="text-gray-500 text-right">
                            <span *ngIf="findOriginalDetail(item.position) as original">
                                {{original.unitPrice | decimalFormat}}
                            </span>
                            <span *ngIf="!findOriginalDetail(item.position)">-</span>
                        </td>
                    </ng-container>

                    <!-- Precio (Después) -->
                    <ng-container matColumnDef="priceAfter">
                        <th mat-header-cell *matHeaderCellDef class="text-right">Precio (Después)</th>
                        <td mat-cell *matCellDef="let item"
                            class="text-right"
                            [class.text-green-600]="findOriginalDetail(item.position)?.unitPrice !== item.unitPrice">
                            {{item.unitPrice | decimalFormat}}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="detailColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: detailColumns;"></tr>
                </table>

                <div *ngIf="getChangedDetails().length === 0" class="text-center py-4 text-gray-500">
                    No hay detalles modificados en esta versión
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

    <!-- Paginación -->
    <mat-paginator *ngIf="totalItems > pageSize" [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex - 1"
        (page)="onPageChange($event)" [pageSizeOptions]="[10, 25, 50, 100]" class="mt-4">
    </mat-paginator>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-4">
    <button mat-button mat-dialog-close class="bg-gray-100 hover:bg-gray-200">Cerrar</button>
</mat-dialog-actions>